/** Site name shown in the UI. Change it here (and in index.html's <title>). */
export const BRAND = 'Revive';
